// Constantes partagées Financeur / Société
export const TYPES_FINANCEUR = [
  { value: 'entreprise', label: 'Entreprise cliente' },
  { value: 'opco', label: 'OPCO' },
  { value: 'particulier', label: 'Particulier' },
  { value: 'cpf', label: 'CPF' },
  { value: 'france_travail', label: 'France Travail' },
  { value: 'region', label: 'Région' },
  { value: 'sous_traitant', label: 'Sous-traitant / Donneur d\'ordre' },
  { value: 'financeur_public', label: 'Financeur public' },
  { value: 'autofinancement', label: 'Autofinancement' },
  { value: 'cofinancement', label: 'Cofinancement multi-acteurs' },
];

export const MODALITES_FACTURATION = [
  { value: 'heure', label: 'À l\'heure' },
  { value: 'heure_stagiaire', label: 'À l\'heure stagiaire' },
  { value: 'journee', label: 'À la journée' },
  { value: 'demi_journee', label: 'À la demi-journée' },
  { value: 'forfait_session', label: 'Forfait session' },
  { value: 'par_candidat', label: 'Par candidat' },
  { value: 'par_groupe', label: 'Par groupe' },
  { value: 'par_parcours', label: 'Par parcours' },
  { value: 'par_module', label: 'Par module' },
  { value: 'par_bloc_competences', label: 'Par bloc de compétences' },
  { value: 'acte', label: 'À l\'acte' },
  { value: 'certification', label: 'Au passage de certification' },
  { value: 'presence_reelle', label: 'Par présence réelle' },
  { value: 'service_realise', label: 'Sur service réalisé' },
  { value: 'mixte', label: 'Facturation mixte' },
];

export const CONDITIONS_REGLEMENT = [
  { value: 'immediat', label: 'Immédiat' },
  { value: '15_jours', label: '15 jours' },
  { value: '30_jours', label: '30 jours' },
  { value: '45_jours', label: '45 jours' },
  { value: '60_jours', label: '60 jours' },
  { value: 'fin_mois', label: 'Fin de mois' },
  { value: 'fin_mois_30', label: 'Fin de mois + 30 jours' },
  { value: 'fin_mois_45', label: 'Fin de mois + 45 jours' },
];

export const MODES_REGLEMENT = [
  { value: 'virement', label: 'Virement bancaire' },
  { value: 'cheque', label: 'Chèque' },
  { value: 'prelevement', label: 'Prélèvement' },
  { value: 'cb', label: 'Carte bancaire' },
  { value: 'especes', label: 'Espèces' },
];

export const MODES_CALCUL = [
  { value: 'tarif_unitaire_x_heures', label: 'Tarif unitaire x heures' },
  { value: 'tarif_unitaire_x_heures_x_stagiaires', label: 'Tarif unitaire x heures x stagiaires' },
  { value: 'tarif_jour_x_jours', label: 'Tarif jour x nombre de jours' },
  { value: 'forfait_fixe', label: 'Forfait fixe' },
  { value: 'par_candidat_inscrit', label: 'Montant par candidat inscrit' },
  { value: 'par_candidat_presente', label: 'Montant par candidat présenté' },
  { value: 'par_candidat_certifie', label: 'Montant par candidat certifié' },
  { value: 'presence_reelle', label: 'Selon présence réelle' },
  { value: 'heures_emargees', label: 'Selon heures émargées' },
  { value: 'plafond_financeur', label: 'Selon plafond financeur' },
];

export const PIECES_JUSTIFICATIVES = [
  { value: 'devis_signe', label: 'Devis signé' },
  { value: 'convention_signee', label: 'Convention signée' },
  { value: 'bon_commande', label: 'Bon de commande' },
  { value: 'accord_prise_en_charge', label: 'Accord de prise en charge' },
  { value: 'emargement', label: 'Feuille d\'émargement' },
  { value: 'attestation_assiduite', label: 'Attestation d\'assiduité' },
  { value: 'certificat_realisation', label: 'Certificat de réalisation' },
  { value: 'facture_acquittee', label: 'Facture acquittée' },
  { value: 'rib', label: 'RIB' },
  { value: 'attestation_honneur', label: 'Attestation sur l\'honneur' },
  { value: 'resultat_certification', label: 'Résultat certification' },
];

